
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kompetisi/iot",
      function () {
        return require("private-next-pages/kompetisi/iot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kompetisi/iot"])
      });
    }
  